import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a8738a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  key: 0,
  class: "tw-h-full tw-flex tw-flex-col"
}

import { onBeforeMount, onBeforeUnmount, ref, watch } from "vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { RIGHT_SLIDE_MODAL_NAME } from "@/utils/constants";
import AssessmentAdvanced from "@/components/assessment/assessmentAdvanced.vue";
import vendorAssessmentExternalAdvanceModal from "@/components/vendor/vendorAssessmentExternalAdvanceModal.vue";
import { IModalMessage } from "@/interfaces/common/common";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'rightSlideModal',
  props: {
  isShow: { type: Boolean, required: true, default: false },
  isShowOverlay: { type: Boolean, required: false, default: true },
},
  emits: ["show", "close"],
  setup(__props, { emit }) {

const props = __props;




// Import component modal here.
const modalComponent = {
  [RIGHT_SLIDE_MODAL_NAME.ASSESSMENT_ADVANCED]: AssessmentAdvanced,
  [RIGHT_SLIDE_MODAL_NAME.ASSESSMENT_REQUESTED_ADVANCED]:
    vendorAssessmentExternalAdvanceModal,
};

const show = ref(false);
const modal: IModalMessage = {
  component: "",
  events: {},
};

onBeforeMount(() => {
  listeningEmitEvent();
});

onBeforeUnmount(() => {
  removeEmitEventListener();
});

const listeningEmitEvent = () => {
  EventEmitter.on(EmitterEvents.OPEN_RIGHT_SLIDE_MODAL, showModal);
  document.addEventListener(
    "keydown",
    (e) => e.key === "Escape" && closeModal(),
  );
};

const removeEmitEventListener = () => {
  EventEmitter.off(EmitterEvents.OPEN_RIGHT_SLIDE_MODAL);
  document.removeEventListener("keydown", () => {});
};

const showModal = async (value) => {
  // Show modal only for Assessment Advanced Search box.
  if (
    value.component === RIGHT_SLIDE_MODAL_NAME.ASSESSMENT_ADVANCED &&
    value.properties?.showOverlay === false
  ) {
    if (value.properties?.questionData && value.properties?.checklistItemId) {
      store.commit("Assessment/SET_CHECKLIST_CURRENT_CHECKLIST_ADVANCED", {
        questionData: value.properties.questionData,
        checklistId: value.properties.checklistId,
        checklistItemId: value.properties.checklistItemId,
        answerOptionsDropDown: value.properties.answerOptionsDropDown,
        answerOption: value.properties.answerOption,
        isRecommend: value.properties.isRecommend,
        isGlobalSearch: value.properties.isGlobalSearch || false,
        show: value.properties.show,
        passkey: value.properties.passkey,
      });
    }

    /**
     * If the modal is already open and the component is the same
     * we don't need to emit show again.
     */
    if (modal.component === value.component) return;
  }

  modal.component = value.component;
  modal.events = value.events;
  modal.properties = value.properties;

  if (modal.component in modalComponent) {
    const showOverlay =
      modal.properties?.showOverlay !== undefined
        ? modal.properties?.showOverlay
        : true;

    await new Promise((resolve) => setTimeout(resolve, 10));
    show.value = true;
    emit("show", showOverlay);
  }
};

const closeModal = () => {
  show.value = false;
  emit("close");

  // Reset modal component and properties when closing.
  modal.component = "";
  modal.events = {};
  modal.properties = {};
  store.commit("Assessment/SET_CHECKLIST_CURRENT_CHECKLIST_ADVANCED", {});
};

watch(
  () => props.isShow,
  () => props.isShow === false && closeModal(),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`right-slider-modal ${show.value ? 'expand' : ''}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: "cross_icon",
        src: "/img/cross-x_icon.svg",
        alt: "cross",
        onClick: closeModal
      }),
      (show.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(modalComponent[modal.component]), _mergeProps({ show: show.value }, modal.properties, _toHandlers({ ...modal.events }), { onClose: closeModal }), null, 16, ["show"]))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})